<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">完善个人信息</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

        <van-cell>
            提示：为了学时统计，请完善个人信息
        </van-cell>

        <van-form label-width="120" @submit="addManger">
            <van-field v-model="user.name" name="user_id" label="姓名:" placeholder="姓名"
                       :rules="[{ required: true, message: '请输入姓名' }]"/>
            <van-field v-model="user.id_card" name="pid" label="身份证号码:" placeholder="身份证号码"
                       :rules="[{ required: true, message: '请输入身份证号码' }]"/>

            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">提交</van-button>
            </div>
        </van-form>


        <van-dialog v-model="loading" title="" :show-confirm-button="false">
            <br>
            <van-loading size="50px" vertical>{{loading_text}}</van-loading>
            <br>
        </van-dialog>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                user: {
                    name:'',
                    id_card:"",
                    phone:""
                },

                loading:false,
                loading_text:"提交中",
            };
        },
        created() {

        },
        methods: {


            addManger() {
                this.loading=true
                this.$http.post("/wechat/user", this.user).then(res => {
                    this.loading=false
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.$toast.fail(res.data.msg);
                        return
                    }
                    this.$toast.success("提交成功")
                    this.$router.push('/my');
                });
            },
        }
    }
</script>
